import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart, X } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { DjayAvatar, DjayBubble } from '../../mascot';
import { OnboardingProgress } from './onboarding/OnboardingProgress';
interface LinkChildPromptProps {
  onLink: (linkCode: string) => void;
  onSkip: () => void;
  isLoading?: boolean;
  error?: string;
  embedded?: boolean;
}
export function LinkChildPrompt({
  onLink,
  onSkip,
  isLoading,
  error,
  embedded = false
}: LinkChildPromptProps) {
  const [linkCode, setLinkCode] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (linkCode.trim().length === 6) {
      onLink(linkCode.trim().toUpperCase());
    }
  };
  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 6) {
      setLinkCode(value);
    }
  };
  const formCard = <div className="bg-white rounded-3xl p-8 shadow-xl border border-emerald-100 relative overflow-hidden" data-id="element-138">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-emerald-400 to-teal-400" data-id="element-139" />

      {embedded && <OnboardingProgress currentStep={1} role="parent" data-id="element-140" />}

      <div className="flex items-center justify-center w-12 h-12 bg-emerald-100 rounded-2xl mb-6 mx-auto" data-id="element-141">
        <Heart className="w-6 h-6 text-emerald-600" data-id="element-142" />
      </div>

      <h2 className="text-2xl font-bold text-center text-gray-900 mb-2" data-id="element-143">
        Koppel je kind
      </h2>
      <p className="text-center text-gray-600 mb-8" data-id="element-144">
        Je vindt de koppelcode op het profiel van je kind.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-145">
        <div data-id="element-146">
          <Input label="Koppelcode" type="text" value={linkCode} onChange={handleCodeChange} placeholder="Bijv. XYZ789" className="text-center text-2xl tracking-widest font-mono uppercase" maxLength={6} required disabled={isLoading} data-id="element-147" />
        
          {error && <p className="mt-2 text-sm text-red-600 text-center" data-id="element-148">{error}</p>}
        </div>

        <div className="space-y-3" data-id="element-149">
          <Button type="submit" className="w-full py-6 text-lg bg-emerald-600 hover:bg-emerald-700 text-white" disabled={linkCode.length !== 6 || isLoading} data-id="element-150">
          
            {isLoading ? 'Bezig met koppelen...' : 'Koppel account'}
            {!isLoading && <ArrowRight className="w-5 h-5 ml-2" data-id="element-151" />}
          </Button>

          {!embedded && <Button type="button" variant="secondary" className="w-full" onClick={onSkip} disabled={isLoading} data-id="element-152">
          
              <X className="w-4 h-4 mr-2" data-id="element-153" />
              Sla over voor nu
            </Button>}
        </div>
      </form>
    </div>;
  if (embedded) {
    return formCard;
  }
  return <div className="min-h-screen bg-emerald-50 flex flex-col items-center justify-center p-4" data-id="element-154">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-155">
        
        {/* Mascot Section */}
        <div className="flex flex-col items-center mb-8 relative" data-id="element-156">
          <DjayBubble message="Welkom! Vul de koppelcode van je kind in om hun voortgang te kunnen volgen." variant="welcome" className="mb-4" data-id="element-157" />
          
          <DjayAvatar emotion="happy" size="lg" data-id="element-158" />
        </div>

        {formCard}
      </motion.div>
    </div>;
}